import { useTranslation } from 'react-i18next';
import { Tooltip } from 'common/components/Tooltip/Tooltip';
import TodayIcon from '@mui/icons-material/Today';
import { palette } from 'theme/palette';

type WidgetDailyUsageIndicatorProps = {
  date?: string;
};

export const WidgetDailyUsageIndicator = ({ date }: WidgetDailyUsageIndicatorProps) => {
  const { t } = useTranslation();

  return (
    <Tooltip
      showArrow={true}
      title={t('graphs.dailyUsageTooltipTitle')}
      description={
        date
          ? t('graphs.dailyUsageLastUpdated', {
              date,
              interpolation: { escapeValue: false },
            })
          : ''
      }
    >
      <TodayIcon sx={{ fill: palette.text.tertiary }} data-testid="TodayIcon" />
    </Tooltip>
  );
};
